// extracted by mini-css-extract-plugin
module.exports = {"modal-add-company__form-controls":"modal-add-company_modal-add-company__form-controls__SCwpC"};